/**
 * Screen — the layout wrapper every screen renders inside.
 *
 * Props:
 *   title?    string  — optional in-page title (Telegram already shows a header;
 *                       pass this only for screens that want a body-level H1).
 *   children  node    — the screen body content (scrolls).
 *   footer?   node    — optional footer slot for an in-page button when the
 *                       screen doesn't use the native MainButton.
 *   bodyClass? string — extra class on the scrolling body (e.g. 'consent').
 *   bodyStyle? object — inline overrides (rarely needed).
 */
export default function Screen({ title, children, footer, bodyClass = '', bodyStyle }) {
  return (
    <div className="screen">
      <div className={`screen__body ${bodyClass}`} style={bodyStyle}>
        {title ? <h1 className="screen__title">{title}</h1> : null}
        {children}
      </div>
      {footer ? <div className="screen__footer">{footer}</div> : null}
    </div>
  );
}
